export const PACKAGE_INFO_ITEM_TEST_ID = 'PACKAGE_INFO_ITEM_TEST_ID';
export const PACKAGE_MEAL_INFO_TEST_ID = 'PACKAGE_MEAL_INFO_TEST_ID';
